<div class="sidebar">
  <div class="sidebar-header">
    <div class="logo">
      <img src="/images/sidebar/logo.svg" alt="Cladded Glass Logo" />
    </div>
  </div>

  <div>
    <div class="flex items-center space-x-2 account-status">
      <p>Account Status:</p>
      <span  [ngClass]="{'inactive': !isCustomerActive}"
      [ngClass]="{'active': isCustomerActive}" class="status">{{customer_overview()?.status ?? "Not found"}}</span>
    </div>

    <nav *ngIf="isLoggedIn" class="menu">
      <ul>
        <!-- Overview -->
        <li>
          <a [routerLink]="['billing', 'overview']" routerLinkActive="active"
            ><img src="/images/sidebar/overview.svg" alt="overview" />
            Overview</a
          >
        </li>

        <!-- Billing and Payment with Dropdown -->
        <li *ngIf="hasSubscriptions">
          <a class="cursor-pointer menu-item">
            <img src="/images/sidebar/payment.svg" alt="payment" />
            Billing And Payment
          </a>
          <ul class="dropdown">
            <li>
              <a
                [routerLink]="['billing', 'make-a-payment']"
                routerLinkActive="active"
                ><span></span> Payments</a
              >
            </li>
<!--             <li>
              <a [routerLink]="['billing', 'methods']" routerLinkActive="active"
                ><span></span> Payment methods</a
              >
            </li> -->
            <li>
              <a
                [routerLink]="['billing', 'invoices']"
                routerLinkActive="active"
                ><span></span> Invoices</a
              >
            </li>
<!--             <li>
              <a
                [routerLink]="['billing', 'transactions']"
                routerLinkActive="active"
                ><span></span> Transactions</a
              >
            </li>
 -->          </ul>
        </li>

<!--        
        <li>
          <a [routerLink]="['billing', 'my-services']" routerLinkActive="active"
            ><img src="/images/sidebar/services.svg" alt="services" /> My
            Services</a
          >
        </li>

       
        <li>
          <a [routerLink]="['billing', 'equipment']" routerLinkActive="active"
            ><img src="/images/sidebar/settings.svg" alt="settings" />
            Equipment</a
          >
        </li>

       
        <li>
          <a [routerLink]="['billing', 'support']" routerLinkActive="active"
            ><img src="/images/sidebar/support.svg" alt="support" /> Support</a
          >
          <ul class="dropdown">
            <li>
              <a
                [routerLink]="['billing', 'all-tickets']"
                routerLinkActive="active"
                ><span></span> All Tickets</a
              >
            </li>
          </ul>
        </li> -->
      </ul>
    </nav>

    <div *ngIf="isLoggedIn" class="w-full">
      <div class="logout">
        <button class="logout-button" (click)="logout()">
          <img src="/images/sidebar/logout.svg" alt="logout" /> Logout
        </button>
        <span class="text-xs">{{email}}</span><br/>
        <span class="text-xs">{{this.env}}</span>
      </div>
    </div>
  </div>
</div>
